import React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  FormControl,
  Alert,
} from "@mui/material";
import { MdOutlineImage } from "react-icons/md";
import { FaYoutube, FaCode, FaLink } from "react-icons/fa";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const RightColNewArticle = ({
  appearUploadDialogAddFile,
  handleNoteEditor,
  newNote,
  handleCreation,
  userCreated,
  showErrorForm,
  setNewNote,
}: any) => {
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid transparent",
    boxShadow: 24,
    p: 4,
    borderRadius: "5px",
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [linkUrl, setLinkUrl] = React.useState("");
  const addLink = () => {
    setNewNote(
      newNote + '<a href="' + linkUrl + '" target="_blank">' + linkUrl + "</a>"
    );
    handleClose();
  };

  const handleLinkUrlChange = (e: any) => {
    setLinkUrl(e.target.value);
  };
  return (
    <>
      <div className="right-col-new-article">
        <div className="editor-menu-wrap">
          <MdOutlineImage
            title="Ajout image"
            onClick={appearUploadDialogAddFile}
            style={{ cursor: "pointer" }}
          />
          <FaYoutube title="Ajout vidéo" style={{ cursor: "pointer" }} />
          <FaCode
            title="Ajout code html"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const code = prompt("Entrez le code HTML à insérer :");
              if (code) {
                setNewNote(newNote + `<textarea style="width:100%;min-height:150px;">${code}</textarea>`);
              }
            }}
          />
          <FaLink
            title="Ajoutez un lien"
            style={{ cursor: "pointer" }}
            onClick={handleOpen}
          />
        </div>
        <div className="editor-wrap">
          <div
            className="note-editor"
            style={{ border: "1px solid #ddd;min-height:400px;" }}
            contentEditable={true}
            onBlur={handleNoteEditor}
            dangerouslySetInnerHTML={{ __html: newNote }}
          ></div>
        </div>

        <input
          type="hidden"
          name="previewImageId"
          onChange={handleCreation}
          value={0}
        />
        <input
          type="hidden"
          name="previewImageSrc"
          onChange={handleCreation}
          value=""
        />

        {/* <FormControl fullWidth sx={{ m: 1, width: "95%" }}>
                                    <TextField id="standard-basic" label="Pseudo" name="userLogin" variant="standard" onChange={handleUserCreation} />
                                </FormControl>

                                <FormControl fullWidth sx={{ m: 1, width: "95%" }}>
                                    <TextField id="standard-basic" label="Adresse e-mail" name="userEmail" variant="standard" onChange={handleUserCreation} />
                                </FormControl> */}

        {/* <FormControl fullWidth sx={{ m: 1, width: "95%" }}>
                                    <TextField id="standard-basic" label="Poste" name="userPost" variant="standard" onChange={handleUserCreation} />
                                </FormControl> */}

        {/* <FormControl fullWidth sx={{ m: 1, width: "95%" }}>
                                    <TextField id="standard-basic" label="Mot de passe" name="userPassword" variant="standard" type="password" onChange={handleUserCreation} />
                                </FormControl> */}

        <Alert
          icon={<CheckIcon fontSize="inherit" />}
          severity="success"
          style={{ display: userCreated ? "flex" : "none" }}
        >
          L'article a bien été enregistré
        </Alert>

        <Alert
          icon={<CloseIcon fontSize="inherit" />}
          severity="error"
          style={{ display: showErrorForm ? "flex" : "none" }}
        >
          Erreur: Cet article existe déjà
        </Alert>
      </div>
      <div style={{ overflowY: "scroll" }}>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div>
              <h3>ajouter un lien</h3>

              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="standard-basic"
                  label="URL"
                  name="linkUrl"
                  variant="standard"
                  onChange={handleLinkUrlChange}
                />
              </FormControl>
              <Button variant="contained" onClick={addLink}>
                ajouter le lien
              </Button>
            </div>
            {/* <div>
                                      <Typography id="user-creation-info" sx={{ mt: 2 }}>
                                          User name: {userCreationState.userName}<br />
                                          User email: {userCreationState.userEmail}<br />
                                          User login: {userCreationState.userLogin}<br />
                                          User post: {userCreationState.userPost} <br />
                                          User pwd: {userCreationState.userPassword}
                                      </Typography>
              </div> */}
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default RightColNewArticle;
